export type AccountGroupName =
  | 'Cash'
  | 'Investment'
  | 'Credit'
  | 'Loan'
  | 'Mortgage'
  | 'Other Asset';

export const ICON_MAP = {
  Cash: 'far fa-money-bill-wave-alt',
  Investment: 'fas fa-chart-bar',
  Credit: 'far fa-credit-card',
  Loan: 'far fa-money-check',
  Mortgage: 'far fa-home',
  'Other Asset': 'far fa-piggy-bank',
};

export const MAX_ITEMS_BEFORE_COLLAPSE = 12;
